import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import './i18n';

const el = document.getElementById("app");

createRoot(el).render(<App />);